import { queryClient } from "src/App";
import { WssSessionEventTypes, WssSessionPayload } from "../types/Wss";
import { RQ_SESSION_LIST_KEY } from "../hooks/useSessionList";

export const resolveWssSessionEvent = (wssPayload: WssSessionPayload) => {
    switch (wssPayload.event) {
        case WssSessionEventTypes.SESSION_STATUS:
            queryClient.removeQueries({ queryKey: [RQ_SESSION_LIST_KEY], exact: false });
            break;
        default:
            break;
    }
};
